import ProductCard from "@/components/ProductCard";
import { KineticLine, Reveal } from "@/components/Kinetic";

const OFFSETS = ["md:mt-0", "md:mt-24", "md:mt-10", "md:mt-32", "md:mt-6", "md:mt-28", "md:mt-0", "md:mt-20"];

export default function Collection({ products }) {
  return (
    <section id="collection" className="px-5 sm:px-10 py-28 sm:py-40">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-20 sm:mb-28">
        <div>
          <Reveal>
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#ff1053] mb-5">The Drop — 001</p>
          </Reveal>
          <h2 className="font-display font-medium uppercase tracking-tighter leading-[0.9] text-5xl sm:text-6xl lg:text-7xl">
            <KineticLine inView>Script</KineticLine>
            <KineticLine inView delay={0.12}>Sets</KineticLine>
          </h2>
        </div>
        <Reveal delay={0.2} className="max-w-sm">
          <p className="text-sm text-white/50 font-light leading-relaxed">
            Eight hoodie-and-jogger uniforms, dye-sublimated so the script never cracks, peels, or fades.
            Priced at real production cost — blanks, print run, press labor — plus a fair margin.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-20">
        {products.map((p, i) => (
          <div key={p.lookup_key} className={OFFSETS[i % OFFSETS.length]}>
            <ProductCard product={p} index={i} />
          </div>
        ))}
      </div>
    </section>
  );
}
